import { PropTypes } from "prop-types";
import { StyledUserCard } from "../../../styles/StyledUserCard/StyledUserCard";
import { MoreActions } from "../../MoreActions";

export default function ParticipantUserCard({
	data,
	color,
	openDropdowns,
	setOpenDropdowns,
	direction,
	moreActionsPosition,
	openModal,
	showOptions,
}) {
	const { id, firstName, lastName } = data;
	const name = firstName + " " + lastName;

	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	return (
		<StyledUserCard color={color} short={true}>
			{showOptions && openDropdowns && (
				<MoreActions
					type={`p${id}`}
					options={[
						{
							display: true,
							testId: `p${id}-delete`,
							name: "Remove participant",
							click: () => openModal(id),
						},
					]}
					isOpen={openDropdowns}
					setIsOpen={setOpenDropdowns}
					isDisabled={false}
					direction={direction}
					moreActionsPosition={moreActionsPosition}
				/>
			)}
			<div className="user-header">
				<div className="user-picture">
					<span>{acronym}</span>
				</div>
				<div>
					<span className="user-label">Name</span>
					<h5>{name}</h5>
				</div>
			</div>
		</StyledUserCard>
	);
}

ParticipantUserCard.propTypes = {
	data: PropTypes.object,
	color: PropTypes.string,
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	refetch: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
	openModal: PropTypes.func,
	showOptions: PropTypes.bool,
};
